import UploadSelectorFileUploadModel from '@/VueComponents/FileUploadSelector/models/uploadSelectorFileUploadModel';
import UploadSelectorFolderUploadModel from '@/VueComponents/FileUploadSelector/models/uploadSelectorFolderUploadModel';
import uploadService from '@/Services/uploadService';
import { useContextDataStore } from '@/VueCore/stores/contextDataStore';
import { UploadParentItemType } from '@/Types/Enums/UploadParentItemType';
import BaseUploadModel from '@/Models/baseUploadModel';
import {
  groupUploadsToFolders,
  isUploadBelongsToFolder
} from '@/VueComponents/Uploads/utils/uploadsUtils';
import UploadModel from '@/Models/uploadModel';

export default function useFileUploader(uploads: BaseUploadModel[],
  requestId: string,
  requestType: UploadParentItemType) {

  const metadataAvailable = requestType !== UploadParentItemType.businessRequest;

  // TODO: Remove when partner request upload file selector is reworked to use new generic FileSelector components
  function uploadFilesObsolete(fileList: FileList | File[], errorCallback: (e:any) => void) {
    const newUploads = uploadService
      .addUploadsAsFiles(fileList, requestId, requestType, metadataAvailable, errorCallback);

    populateWithNewUploadModels(newUploads);
  }

  function uploadFiles(files: UploadSelectorFileUploadModel[], folders: UploadSelectorFolderUploadModel[], errorCallback: (e:any) => void) {
    files = files || [];
    folders = folders || [];

    const fileList = [...files, ...folders.flatMap(f => f.generateFileUploadModels())];
    const newUploads = uploadService.addUploads(fileList, requestId, requestType, metadataAvailable, errorCallback);

    populateWithNewUploadModels(newUploads);
  }

  function populateWithNewUploadModels(newUploads: UploadModel[]) {
    const contextData = useContextDataStore();
    newUploads.forEach(u => {
    // Upload manager creates upload model before it's actually created on the backend so
    // some data can be missing. Put personaDisplayName manually for the correct displaying uploads in table.
      if (!u.personaDisplayName) {
        u.personaDisplayName = contextData.userData.displayName();
      }
    });

    const folderUploadModels = newUploads.filter(isUploadBelongsToFolder);

    const folderUploads = groupUploadsToFolders(folderUploadModels);
    const singleUploads = newUploads.filter(f => !isUploadBelongsToFolder(f));

    if (folderUploads.length > 0) {
      uploads.unshift(...folderUploads);
    }
    if (singleUploads.length > 0) {
      uploads.unshift(...singleUploads);
    }
  }

  return { uploadFiles, uploadFilesObsolete };
}

